import * as e from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/TextHOne.es.js";
const o = e.forwardRef((t, r) => /* @__PURE__ */ e.createElement(n, { ref: r, ...t, weights: a }));
o.displayName = "TextHOneIcon";
const s = o;
export {
  s as TextHOne,
  o as TextHOneIcon
};
